module.exports = __webpack_public_path__ + "media/images/icons/google-f593e2b8c1488c4c72c2580b3e84923c.svg";